import { Button, Result } from "antd";
import type { ReactNode } from "react";
import { Component } from "react";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("Unhandled application error", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
          <Result
            status="error"
            title="The app hit an unexpected error"
            subTitle="Reload the page to recover. If this keeps happening, check the browser console and API logs."
            extra={
              <Button type="primary" onClick={() => window.location.reload()}>
                Reload app
              </Button>
            }
          />
        </div>
      );
    }

    return this.props.children;
  }
}
